// WhatsApp invites sent by hand from the owner's own WhatsApp (click-to-chat).
// No SMS template or WhatsApp Business account is needed, and nothing is sent
// unless the owner presses send in WhatsApp.

/** wa.me link to one Indian mobile (any common format), or to any chat when the number is unknown. */
export function whatsappUrl(phone: string | undefined, text: string): string {
  const digits = (phone ?? '').replace(/\D/g, '').slice(-10);
  const to = /^[6-9]\d{9}$/.test(digits) ? `91${digits}` : '';
  return `https://wa.me/${to}?text=${encodeURIComponent(text)}`;
}

const first = (name: string) => name.trim().split(/\s+/)[0] || 'there';

/** For pump staff the owner just added. Attendants can work from the pump's counter phone without signing in. */
export function staffInviteText(input: { personName: string; businessName: string; roleLabel: string; attendant: boolean; pumpName?: string; pinSet: boolean; webBase: string }): string {
  const own = `To use your own phone: open ${input.webBase}, tap Continue with Google, and confirm this mobile number.`;
  if (!input.attendant) {
    return `Hi ${first(input.personName)}, ${input.businessName} has added you as ${input.roleLabel} on SuperIndent. ${own}`;
  }
  return [
    `Hi ${first(input.personName)}, ${input.businessName} has added you as a pump attendant${input.pumpName ? ` at ${input.pumpName}` : ''} on SuperIndent.`,
    `At the pump's counter phone: open SuperIndent, tap Fill fuel, tap your name and enter your PIN${input.pinSet ? ' (your manager will tell you)' : ' (your manager will set it)'}.`,
    `${own} Then set your PIN in My account.`,
  ].join('\n');
}

/** For a driver the fleet just added. Drivers never need the app. */
export function driverInviteText(input: { personName: string; businessName: string }): string {
  return `Hi ${first(input.personName)}, ${input.businessName} has added you as a driver on SuperIndent. You do not need the app: your fuel code and QR will come to you on WhatsApp. Show it to the pump attendant when you fill.`;
}
